var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChild = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 14",
    style: {
      enableBackground: "new 0 0 12 14"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    transform: "translate(23.278 -64.668)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    className: "parent-icon",
    cx: -17.3,
    cy: 68.8,
    rx: 4.2,
    ry: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    className: "parent-icon",
    d: "M-23.3,77.5c1.5,1.5,10.4,1.5,11.9,0v-0.1c0-1.8-1.5-3.3-3.4-3.3h-5.2 C-21.8,74.1-23.3,75.6-23.3,77.5C-23.3,77.5-23.3,77.5-23.3,77.5L-23.3,77.5L-23.3,77.5z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChild);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Child.5f425df4b762076f1d34b09c3e1e1a9e.svg";